import { variables } from '@bitrise/bitkit';
import { VizContext } from '@bitrise/bitviz';
import React, { useContext, FunctionComponent } from 'react';
import { EventSeriesPoint, PADDING_HORIZONTAL } from './SessionEventsVisualisation';
import SessionEventsVisualisationSeriesPoint from './SessionEventsVisualisationSeriesPoint';
import './SessionEventsVisualisationSeries.css';

interface Props {
  focusPoint: null | EventSeriesPoint;
  series: EventSeriesPoint[];
}

const SessionEventsVisualisationSeries: FunctionComponent<Props> = (props: Props) => {
  const { focusPoint, series } = props;

  const { artboardHeight, artboardLeft, artboardWidth, artboardTop } = useContext(VizContext);

  return (
    <g className="EventsSeries">
      <rect
        fill={variables.colorGray2}
        height={artboardHeight}
        width={artboardWidth + PADDING_HORIZONTAL * 2}
        x={artboardLeft - PADDING_HORIZONTAL}
        y={artboardTop}
      />

      {series.map((point) => (
        <SessionEventsVisualisationSeriesPoint
          focus={focusPoint === point}
          key={point.id}
          point={point}
        />
      ))}
    </g>
  );
};

export default SessionEventsVisualisationSeries;
